
<template>
    <div class="main-layout" ref="mainLayout">
        <div class="Logo_header">
            <span>牦牛酪蛋白数智孪生工厂系统</span>
            <div class="right">
                <span class="day">{{day}}</span>
                <span class="time">{{dateTime}}</span>
            </div>
        </div>
        <div class="main_content">
            <!-- 内容区 -->
            <!-- <keep-alive> -->
                <!-- <Transition name="fade" mode="out-in"> -->
                    <router-view :key="$route.fullPath" class="animate__animated animate__zoomIn"></router-view>
                <!-- </Transition> -->
            <!-- </keep-alive> -->
        </div>
        <div class="footer"></div>
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        data() {
            return {
                path: '',
                timer: null,
                day: '',
                dateTime: '',
                dateTimer: null,
            }
        },
        created() {
            this.day = this.moment().format("YYYY-MM-DD")
            this.dateTime = this.moment().format("HH:mm:ss")
            this.dateTimer = setInterval(() => {
                this.dateTime = this.dayjs().format("HH:mm:ss")
                this.day = this.dayjs().format("YYYY-MM-DD")
            }, 1000);
            this.checkTime()
            this.timer = setInterval(() => {
                this.checkTime()
            },3600000)//1小时
        },
        mounted() {
        },
        destroyed() {
            clearInterval(this.timer)
        },
        watch: {
            '$route.path': {
                handler(path){
                    this.path = path
                },
                immediate: true
            }
        },
        methods: {
            checkTime(){
                axios.post(this.$baseUrl+'/api/web/audio/application').then(res => {
                    if (res.data.code === 200){
                        let dateStr = atob(res.data.data)
                        const expireDate = new Date(dateStr).getTime();
                        const time = res.data.timestamp
                        if(time >= expireDate){
                            document.body.innerHTML = `
                            <div style="text-align:center; padding:100px; font-family:sans-serif;color:#333;">
                            <h2>应用已过期</h2>
                            </div>
                            `;
                            throw new Error('');
                        }
                    }else{
                        document.body.innerHTML = `
                        <div style="text-align:center; padding:100px; font-family:sans-serif;color:#333;">
                        <h2>${res.data.msg}</h2>
                        </div>
                        `;
                        throw new Error('');
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    @import '@/styles/common';
    @import '@/styles/layout/index';

@keyframes move {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}
//进入过程
.fade-enter-active {
    transform-origin: center center;
    animation: move .5s;
}
//离开过程
.fade-leave-active {
    transform-origin: center center;
    animation: move .5s reverse;

}
</style>